<template>
  <div class="border-bottom p-4 bg-body">
    <div class="overflow-hidden py-2 px-4 px-md-0 d-flex justify-center">
      <VueSlickCarousel
        ref="carousel"
        class="w-75"
        :arrows="true"
        :dots="true"
        v-bind="settings"
      >
        <div
          v-for="(module, index ) in modules.map((m,i) => { m.block.suffix = ` - Modulo ${++i}` ; return m})"
          :key="index"
          class="d-flex justify-content-between"
        >
          <div class="icon-container d-flex justify-content-center">
            <TimelineIcon
              :module="module"
              :title-on-top="true"
              :icon="module.cycle_status"
              :title="`Módulo ${index + 1}`"
              :disabled-tooltip="module.cycle_status !== 'lock'"
              :show-tooltip="module.cycle_status == 'lock'"
              :subtitle="module.name"
              @click="onClickIcon(module)"
            >
              Clique para saber mais
            </TimelineIcon>
          </div>
          <div
            v-if="index != modules.length - 1 && $vuetify.breakpoint.lgAndUp"
            class="divider d-flex justify-center flex-column"
          >
            <hr :class="`${module.finished_cycle_module ? 'border-solid': 'border-dash'}`">
          </div>
        </div>
      </VueSlickCarousel>
    </div>
    <v-dialog
      v-model="showModulePreview"
      width="600"
      :overlay-opacity="DEFAULT_MODAL_OPACITY"
      :overlay-color="DEFAULT_MODAL_OVERLAY_COLOR"
    >
      <ModulePreview
        v-if="selected_module && showModulePreview"
        :module="selected_module"
      >
        <div class="d-flex justify-content-center w-100">
          <v-btn
            color="nitro"
            text
            @click="showModulePreview = false"
          >
            Fechar
            <v-icon
              right
              dark
            >
              fa fa-times
            </v-icon>
          </v-btn>
        </div>
      </ModulePreview>
    </v-dialog>
  </div>
</template>

<script>

import TimelineIcon from "@/common/components/TimelineIcon.vue";
import ModulePreview from "@/student/pages/module/components/ModulePreview.vue";
import VueSlickCarousel from 'vue-slick-carousel'
import settings from './carousel_settings'
import {DEFAULT_MODAL_OPACITY, DEFAULT_MODAL_OVERLAY_COLOR} from "@/student/constants/general"


export default {
  components: { TimelineIcon, VueSlickCarousel, ModulePreview },
  props: {
    modules: {
      type: Array,
      required: true,
    }
  },
  data() {
      return {
        settings,
        selected_module: null,
        showModulePreview: false,
        DEFAULT_MODAL_OPACITY,
        DEFAULT_MODAL_OVERLAY_COLOR,
      }
  },
  methods:{
    onClickIcon(module){
      if(module.cycle_status === 'lock'){
        this.selected_module =  module ;
        this.showModulePreview=true
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .icon-container{
    @media screen and (max-width: 767px) {
      width: 100%;
    }
    width: 55%;
  }
  .divider {
    width: 100%;
    hr {
      margin-top: -20px;
      border-width: 2px 0 0 0;
      &.border-dash {
        border-style: dashed;
      }
      &.border-solid {
        border-style: solid;
      }
    }
  }
</style>
